import React from 'react'
import { BiChevronRight } from 'react-icons/bi'
import { segSearch } from '../../../assets/'

import './stylesIBtt.css'

export default function InstaBtt() {
  return (
    <div className='contain-home-user-empresas-insta'>
      <button
        className='btt-chama-insta'
        onClick={() => {
          window.open('https://www.instagram.com/agendeiquadras/', '_blank')
        }}
      >
        <img src={segSearch} alt='Não encontrado!' />
        <div>
          <h3>Não encontrou sua quadra favorita?</h3>
          <h4>Manda o @ deles no nosso Instagram :D</h4>
        </div>
        <BiChevronRight size={30} color='#DA5A34' />
      </button>
    </div>
  )
}
